import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-go-overview-step-three',
    imports: [],
    templateUrl: './go-overview-step-three.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../../go-overview.component.scss'],
})
export class GoOverviewStepThreeComponent {}
